export function removeDuplicatesFromArr<T = unknown>(arr: T[]): T[] {
	if (arr.every((v) => typeof v === 'object')) {
		const bufferArr = Array.from(new Set(arr.map((v) => JSON.stringify(v))));

		return bufferArr.map((v) => JSON.parse(v));
	}

	return Array.from(new Set(arr));
}
